module.exports = __webpack_public_path__ + "img/product-8.18e68426.jpg";